import { getScaledImageSource } from 'atc-js';

function getScaledImageSrc(inventory) {
    const imgIndex = inventory?.images?.primary || 0;

    if (inventory.images?.sources?.[imgIndex]?.src) {
        return getScaledImageSource({
            src: inventory.images.sources[imgIndex].src,
            height: 157,
            width: 203,
            bgColor: 'e6e6e6',
            disableBorderScaler: false,
        });
    }
    return '';
}

export default getScaledImageSrc;
